const Footer : React.FC = () => {
    

    return (
        <div className="footer-app">
            Copyright © {new Date().getFullYear()} <strong>DXpress</strong> Todos los Derechos Reservados
        </div>
    );
};

export default Footer;